"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AXIS_LINE_COLOR = exports.mapColors = exports.parseColor = exports.DEFAULT_COLORS = exports.COLOR_PALETTE = exports.SEQUENTIAL_COLOR_RANGES = exports.DIVERGING_COLOR_RANGES = exports.NAMED_COLORS = exports.KEY = void 0;
const color_string_1 = __importDefault(require("color-string"));
const lodash_1 = __importDefault(require("lodash"));
exports.KEY = 'usa';
exports.NAMED_COLORS = {
  magenta: '#E62790',
  'navy-blue': '#00347B',
  cyan: '#249EDC',
  'teal-green': '#00906E',
  purple: '#6929C4',
  'mid-blue': '#20659D',
  pink: '#CF77AD',
  'dark-magenta': '#851C6A',
  'light-purple': '#A56EFF',
  'emerald-green': '#006600',
  blue: '#015193',
  gray: '#949494',
  'dark-green': '#004837',
  republican: '#D5205E',
  democrat: '#1571A9',
  independent: '#00906E'
};
exports.DIVERGING_COLOR_RANGES = {
  'yellow-teal-9-bin': ['#CC6A19', '#D99522', '#E5BD3F', '#F2E289', '#F1F1F1', '#97DFC7', '#5CB79A', '#00906E', '#004837'],
  'purple-teal-9-bin': ['#3C2A9A', '#7756B2', '#A786CB', '#D3B9E6', '#F1F1F1', '#97DFC7', '#5CB79A', '#00906E', '#004837'],
  'red-blue-9-bin': ['#A7004C', '#EC2D66', '#F28BA9', '#F1D1DA', '#F1F1F1', '#B8DAEB', '#3DA8DF', '#1571A9', '#043D70'],
  'yellow-teal-6-bin': ['#CC6A19', '#E5BD3F', '#F2E289', '#97DFC7', '#00906E', '#004837'],
  'purple-teal-6-bin': ['#3C2A9A', '#7756B2', '#D3B9E6', '#97DFC7', '#00906E', '#004837'],
  'red-blue-6-bin': ['#EC2D66', '#F28BA9', '#F1D1DA', '#B8DAEB', '#3DA8DF', '#1571A9'],
  'yellow-teal-5-bin': ['#CC6A19', '#E5BD3F', '#F1F1F1', '#5CB79A', '#004837'],
  'purple-teal-5-bin': ['#3C2A9A', '#A786CB', '#F1F1F1', '#5CB79A', '#004837'],
  'red-blue-5-bin': ['#A7004C', '#F28BA9', '#F1F1F1', '#3DA8DF', '#043D70']
};
exports.SEQUENTIAL_COLOR_RANGES = {
  'magenta-9-bin': ['#E8D7FA', '#E2B5ED', '#E390D6', '#E565B7', '#E62790', '#B4228E', '#7F2386', '#4A2076', '#091A60'],
  'blue-9-bin': ['#D4DAFA', '#B7C9F4', '#95BAED', '#6BACE5', '#249EDC', '#037BC0', '#005AA2', '#013A82', '#091A60'],
  'teal-9-bin': ['#E8FACF', '#BCDFB0', '#8EC495', '#5AAA7F', '#00906E', '#00777E', '#005C88', '#003E7F', '#091A60'],
  'purple-9-bin': ['#DED9FB', '#C0B2F6', '#A58CED', '#8D63E2', '#7735D4', '#5831B8', '#3C2A9A', '#22237D', '#091A60'],
  'magenta-6-bin': ['#E8D7FA', '#E390D6', '#E62790', '#B4228E', '#4A2076', '#091A60'],
  'blue-6-bin': ['#D4DAFA', '#95BAED', '#249EDC', '#037BC0', '#013A82', '#091A60'],
  'teal-6-bin': ['#E8FACF', '#8EC495', '#00906E', '#00777E', '#003E7F', '#091A60'],
  'purple-6-bin': ['#DED9FB', '#A58CED', '#7735D4', '#5831B8', '#22237D', '#091A60'],
  'magenta-5-bin': ['#E8D7FA', '#E390D6', '#E62790', '#7F2386', '#091A60'],
  'blue-5-bin': ['#D4DAFA', '#95BAED', '#249EDC', '#005AA2', '#091A60'],
  'teal-5-bin': ['#E8FACF', '#8EC495', '#00906E', '#005C88', '#091A60'],
  'purple-5-bin': ['#DED9FB', '#A58CED', '#7735D4', '#3C2A9A', '#091A60']
};
/** Go over all 3 lists, merge them into an object a
 * prefix and then the color (or color array) after
 */
exports.COLOR_PALETTE = [{
  key: exports.KEY,
  list: exports.NAMED_COLORS
}, {
  key: exports.KEY,
  list: exports.DIVERGING_COLOR_RANGES
}, {
  key: exports.KEY,
  list: exports.SEQUENTIAL_COLOR_RANGES
}].reduce((spectrum, _ref) => {
  let {
    key,
    list
  } = _ref;
  return {
    ...spectrum,
    ...Object.keys(list).reduce((obj, color) => ({
      ...obj,
      [`${key}-${color}`]: list[color]
    }), {})
  };
}, {});
exports.DEFAULT_COLORS = Object.values(exports.NAMED_COLORS);
const parseColor = function () {
  let color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let defaultColor = arguments.length > 1 ? arguments[1] : undefined;
  if (exports.COLOR_PALETTE[color]) {
    return exports.COLOR_PALETTE[color];
  }
  if (color_string_1.default.get(color)) {
    return color;
  }
  return defaultColor;
};
exports.parseColor = parseColor;
const mapColors = (data, color, defaultColor) => data.map((d, i) => {
  const c = lodash_1.default.isArray(color) && color[i] ? color[i] : color;
  let dc = lodash_1.default.isArray(color) && exports.DEFAULT_COLORS[i] ? exports.DEFAULT_COLORS[i] : exports.DEFAULT_COLORS[0];
  if (defaultColor) {
    dc = lodash_1.default.isArray(defaultColor) && defaultColor[i] ? defaultColor[i] : defaultColor;
  }
  return (0, exports.parseColor)(c, dc);
});
exports.mapColors = mapColors;
exports.AXIS_LINE_COLOR = '#E6E6E6';